import React from "react";
import Hero from "../components/hero";
import GroupInfo from "../components/group-info";
import Map from "../components/map";
import Footer from "../components/footer";

function About() {
  return (
    <>
      <Hero />
      <GroupInfo />
      <Map />
      <Footer />
    </>
  );
}

export default About;
